import { render, staticRenderFns } from "./DNNMainPage.vue?vue&type=template&id=6790f7fb&scoped=true&"
import script from "./DNNMainPage.vue?vue&type=script&lang=js&"
export * from "./DNNMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6790f7fb",
  null
  
)

export default component.exports